import { render, staticRenderFns } from "./NotificationDisabled.vue?vue&type=template&id=4d457738&scoped=true"
import script from "./NotificationDisabled.vue?vue&type=script&lang=js"
export * from "./NotificationDisabled.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d457738",
  null
  
)

export default component.exports